var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3536 9.35355C12.1583 9.15829 11.8417 9.15829 11.6464 9.35355L7.85355 13.1464C7.53857 13.4614 7.76165 14 8.20711 14L15.7929 14C16.2383 14 16.4614 13.4614 16.1464 13.1464L12.3536 9.35355Z",
    fill: "currentColor"
  })));
};
export default SvgChevronUp;